import {
  type InitSalesOrderDraftDTO,
  SalesOrderDraftsService,
} from "../../../api/salesOrderDrafts"
import { SalesOrdersService } from "../../../client"
import { useCreateWarehouseDocumentDraft } from "../shared/useCreateWarehouseDocumentDraft"

type CreateZSOptions = {
  preferredWarehouseId?: string
  replace?: boolean
  prefilledItems?: any[]
}

export function useCreateZS() {
  const { createDocument, isCreating, isResolvingWarehouses, canCreate } =
    useCreateWarehouseDocumentDraft<
      InitSalesOrderDraftDTO,
      { id: string },
      CreateZSOptions
    >({
      mutationKey: ["wms", "sales-orders"] as const,
      documentCode: "ZS",
      blockedWarehouseDescription:
        "Magazyn z kontekstu jest obecnie zablokowany przez aktywną inwentaryzację.",
      missingWarehouseDescription:
        "Brak aktywnego magazynu dostępnego do utworzenia dokumentu ZS.",
      createDraftRequest: async (payload, options?: CreateZSOptions) => {
        const draft = await SalesOrderDraftsService.initSalesOrderDraft(payload)
        if (options?.prefilledItems && options.prefilledItems.length > 0) {
          await SalesOrdersService.updateSalesOrderByID(draft.id, {
            items: options.prefilledItems.map(
              (item) =>
                ({
                  product_id: item.product_id,
                  qty: item.qty,
                  price: item.price,
                  vat_rate: item.vat_rate,
                  location_code: item.location_code,
                  warehouse_lot_id: item.warehouse_lot_id,
                  partia: item.partia,
                  lot_no: item.lot_no,
                  production_date: item.production_date,
                  expiration_date: item.expiration_date,
                }) as any,
            ),
          })
        }
        return draft
      },
      buildPayload: (warehouseId) => ({
        warehouse_id: warehouseId,
      }),
      getSuccessNavigation: (draft, options) => ({
        to: "/WMS/documents/sales-orders/$salesOrder",
        params: { salesOrder: draft.id },
        search: { tab: "general", mode: "edit" },
        replace: Boolean(options?.replace),
      }),
    })

  return {
    createZS: (options?: CreateZSOptions) => createDocument(options),
    isCreating,
    isLoadingWarehouses: isResolvingWarehouses,
    canCreate,
  }
}
